export const leaveTemplate = (
  auth: any,
  leaveData: any,
  actionType: "Applied" | "Cancelled"
) => {
  const leaveTypeName = 
    actionType === "Applied" ? getLeaveTypeName(leaveData.leave_type):leaveData.leave_type_name; 
  const subject =
    actionType === "Applied" ? "Leave Application" : "Leave Cancellation";
  const message =
    actionType === "Applied"
      ? `I would like to inform you that <strong>${auth.userInfo.first_name}</strong> has applied for <strong>${leaveData.leave_type_name}</strong> starting from <strong>${leaveData.start_date}</strong> via the employee portal.`
      : `I would like to inform you that <strong>${auth.userInfo.first_name}</strong> has cancelled their previously requested <strong>${leaveData.leave_type_name}</strong> for <strong>${leaveData.start_date}</strong> via the employee portal.`;

  return ` 
      <html>
      <head>
         <style>
          body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            margin: 0;
            padding: 0;
            background-color: #f9f9f9;
          }
          .container {
            width: 70%;
            margin: auto;
            background-color: #ffffff;
            padding: 30px;
            border-radius: 10px;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
            margin-top: 50px;
            margin-bottom: 50px;
            overflow: hidden;
            text-align: left;
          }
          .header {
            background-color: #2c3e50;
            color: #ffffff;
            text-align: center;
            padding: 10px;
            border-radius: 10px 10px 0 0;
            margin-bottom: 30px;
            font-size: 24px;
            font-weight: bold;
          }
          .footer {
            background-color: #ecf0f1;
            color: #7f8c8d;
            text-align: center;
            padding: 15px;
            border-radius: 0 0 10px 10px;
            margin-top: 30px;
            font-size: 12px;
          }
          h1, h3 {
            color: #2c3e50;
            margin-bottom: 10px;
            font-size: 18px;
          }
          p {
            color: #34495e;
            line-height: 1.6;
            margin: 10px 0;
            font-size: 14px;
          }
          ul {
            padding-left: 20px;
            color: #34495e;
          }
          ul li {
            margin-bottom: 8px;
          }
          strong {
            color: #2c3e50;
          }
          .highlight {
            color: #2c3e50;
            font-weight: bold;
          }
          a {
            color: #2c3e50;
            text-decoration: none;
          }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="header">
            <h2>${subject} Notification</h2>
          </div>
          <p>Dear CEO/Product Manager/Project Lead,</p>
          <p>${message}</p>
          <p>The details of the request are as follows:</p>
          <ul>
            <li><strong>Employee Name:</strong> ${auth.userInfo.first_name}</li>
            <li><strong>Leave Type:</strong>${
              actionType === "Applied"
                ? leaveData.leave_type
                : leaveData.leave_type_name
            } </li>
            <li><strong>Leave Type:</strong>${leaveTypeName} </li>

            <li><strong>Start Date:</strong> ${leaveData.start_date}</li>
            <li><strong>End Date:</strong>${
              actionType === "Applied" ? leaveData.end_date : leaveData.end
            } </li>
            <li><strong>Leave Duration:</strong>${
              actionType === "Applied"
                ? leaveData.leave_duration
                : leaveData.duration
            } </li>
            <li><strong>Reason:</strong> ${
              leaveData.reason || "Not specified"
            }</li>
          </ul>
          <p>Kindly adjust the schedule accordingly, if necessary.</p>
          <p>Thanks and regards,</p>
          <p><strong>INSYTIX.Ind.Pvt.Ltd.</strong></p>
          <div class="footer">
            <p>This is an automated message. Please don't reply.</p>
            <p>&copy; ${new Date().getFullYear()} INSYTIX.Ind.Pvt.Ltd. All rights reserved.</p>
          </div>
        </div>
      </body>
    </html>
    `;
};

const getLeaveTypeName = (leaveType: number | string) => {
  const leaveTypes: { [key: string]: string } = {
    "1": "PTO",
    "2": "Emergency PTO",
    "3": "Floating Holiday",
    "4": "Work from Home",
    "5": "Comp Off",
    "6": "Loss of Pay",
  };

  return leaveTypes[leaveType.toString()] || "Unknown Leave Type";
};
